import { EventContentArg } from '@fullcalendar/core';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CalendarEvent } from '../../../../sic-lib/types/CalendarEvent';

const useStyles = makeStyles()(theme => ({
    root: {
        overflow: 'hidden',
        height: '100%',
    },
}));

interface Props {
    fcCalendarEvent: EventContentArg;
    calendarEvent: CalendarEvent | undefined;
}

export default function MultilineCalendarEventContent({ fcCalendarEvent, calendarEvent }: Props) {
    const { classes } = useStyles();

    const contactName =
        calendarEvent && calendarEvent.contactName ? 'with ' + calendarEvent.contactName : '';

    return (
        <div className={classes.root}>
            <div>
                <Typography variant="body2">
                    {fcCalendarEvent.event.title} {contactName}
                </Typography>
            </div>
            <div>
                <Typography variant="caption">{fcCalendarEvent.timeText}</Typography>
            </div>
        </div>
    );
}
